export enum LanguageCode {
    GERMAN = 'de',
    GERMAN_DE = 'de-DE',
    GERMAN_AT = 'de-AT',
    ENGLISH = 'en',
    ENGLISH_GB = 'en-GB',
    ENGLISH_US = 'en-US',
    FRENCH = 'fr',
};
